import React , {useState} from 'react'
import { Modal as Mod } from "react-responsive-modal";
import { useTranslation} from "react-i18next";


import VideoPlayer from '../VideoPlayer/VideoPlayer'
import {images} from '../../constants'
import './Modal.scss'


function Modal(props) {
    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches)
    const handler = e => setIsMobile(e.matches);
    window.matchMedia("(max-width: 768px)").addEventListener('change', handler);
    const { t } = useTranslation();
  return (
      <>
<div className='app__modal-container'>
        <Mod open={props.open} onClose={props.onCloseModal}>
            {/* {isMobile ? 
            <div className='app__modal-sorry'>
                <img src={images.sorryIllustration} alt='Sorry'/>
                <h2 className="app_modal-about-sorry-title">Sorry!</h2>
                <div className='app__modal-sorry-description'>My video player is not yet supported by mobile devices 😂, I promise to fix it in no time ✌️.</div>
            </div>:  
            <>
            <h2 className="app_modal-title">{props.title}</h2>
          <div className='app__modal-videoplayer'>
        <VideoPlayer videoUrl={props.videoUrl} isMobile={isMobile}/>
        </div>
        <h2 className="app_modal-about-title">About This Project</h2>
        <div className='app__modal-description'>{props.description}</div>
        </>} */}
        <>
            <h2 className="app_modal-title">{props.title}</h2>
          <div className='app__modal-videoplayer'>
        <VideoPlayer videoUrl={props.videoUrl} isMobile={isMobile}/>
        </div>
        <h2 className="app_modal-about-title">{t('about-project')}</h2>
        <div className='app__modal-description'>{props.description}</div>
        </>
         
        </Mod>
      </div>
      </>
  )
}

export default Modal